import { notifierStore } from "../store";

export type AppErrorCode = "criar_carrinho"

export class AppError extends Error {
    constructor(message: string) {
        super(message);
    }

    openNotifier() {
        notifierStore.setNotifier({
            content: this.message,
            title: "Erro",
            noTimeOut: true,
            onClose: () => notifierStore.setOpen(false)
        })

        notifierStore.setOpen(true);
    }
}